// OpenLigaDB team IDs (stable across seasons and leagues)
export const TEAM_IDS = {
    men: 100,
    women: 6324,
};
export const MATCH_END_TIME = 2.5 * 60 * 60 * 1000;
export const API_BASE_URL = "https://api.openligadb.de";
// look one week back (running matches) and half a year ahead (summer / winter break)
export const MATCH_WEEKS_BACK = 1;
export const MATCH_WEEKS_AHEAD = 26;
